<template>
    <v-container>
        <v-card style="background-color:transparent !important;">
            <v-card-title class="justify-center primary">
                <v-toolbar-title id="titulocard">Movimientos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">mdi-text-box-multiple-outline</v-icon>
            </v-card-title>
            <v-card-text v-if="movimientos">
                <div class="table-responsive" v-if="this.aiclave != 5">
                    <template v-if="this.aiclave == 1 || this.aiclave == 24">
                        <v-switch v-model="switchci" label="Movimientos con CI" class="pa-3" inset
                            @change="movimientossinCI()"></v-switch>
                    </template>
                    <table :id="tableName" class="table table-hover display responsive no-wrap" width="100%">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="encabezado in headers" :key="encabezado.id">
                                    {{ encabezado.text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="movimiento in datos" :key="movimiento.id">
                                <td></td>
                                <td>{{ movimiento.exfecha }}</td>
                                <td>{{ movimiento.ceconcepto }}</td>
                                <td>{{ movimiento.Respuesta }}</td>
                                <td>{{ movimiento.cegrupo }}</td>
                                <td>{{ movimiento.exobs }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-responsive" v-else>
                    <template>
                        <v-switch v-model="switchci" label="Movimientos con CI" class="pa-3" inset
                            @change="movimientossinCI()"></v-switch>
                    </template>
                    <table :id="tableName" class="table table-hover display responsive no-wrap" width="100%">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="encabezado in encabezados" :key="encabezado.id">
                                    {{ encabezado.text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="movimiento in datos" :key="movimiento.id">
                                <td></td>
                                <td>{{ movimiento.hmfolio }}</td>
                                <td>{{ movimiento.hmfecha }}</td>
                                <td>{{ movimiento.crinstancia }}</td>
                                <td>{{ movimiento.cretapa }}</td>
                                <td>{{ movimiento.hmactualizacion }}</td>
                                <td>{{ movimiento.uslogin }}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </v-card-text>
            <v-card-text v-else>
                <div class="text-center">
                    <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Expediente from '@/services/expediente/expediente.service.js';

import "jquery/dist/jquery.min.js";
/* import "bootstrap/dist/css/bootstrap.min.css"; */
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import "datatables.net-responsive-dt";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";

export default {
    data: function () {
        return {
            headers: [
                { text: 'Fecha', value: 'exfecha', class: "text title", width: "100" },
                { text: 'Concepto', value: 'ceconcepto', class: "text title", width: "100" },
                { text: 'Respuesta', value: 'Respuesta', class: "text title", width: "50" },
                { text: 'Tipo', value: 'cegrupo', class: "text title", width: "50" },
                { text: 'Observaciones', value: 'exobs', class: "text title", width: "100" },
            ],
            encabezados: [
                { text: 'Folio', value: 'hmfolio', align: 'left', width: "50" },
                { text: 'Fecha', value: 'hmfecha', width: "50" },
                { text: 'Instancia', value: 'crinstancia', width: "50" },
                { text: 'Etapa', value: 'cretapa', width: "100" },
                { text: 'Actualización', value: 'hmactualizacion', width: "100" },
                { text: 'Usuario', value: 'uslogin', width: "100" },
            ],
            datos: [],
            movimiento: [],
            switchci: true,
            aiclave: '',
            datosConCI: [],
            prefix: "tabla_",
            randomNum: Math.floor(Math.random() * 1000),
            movimientos: false,

        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
        tableName() {
            return this.prefix + this.randomNum;
        },
    },
    async mounted() {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.aiclave = datos.aiclave;
        await this.ObtenerRegistros();
    },
    methods: {
        async movimientossinCI() {
            this.movimientos = false;
            $("#" + this.tableName + "_paginate").empty();
            $("#" + this.tableName + "_info").remove();
            $("#" + this.tableName + "_filter").remove();
            $("#" + this.tableName + "_length").remove();
            this.randomNum = Math.floor(Math.random() * 1000);
            if (this.switchci == false) {
                await this.ObtenerRegistrosSinCI();
            } else {
                await this.ObtenerRegistros();
            }
        },
        async ObtenerRegistros() {
            let response = await Expediente.ObtenerRegistrosExp(this);
            let datos = response;
            for (let i in datos) {
                for (const [key, value] of Object.entries(datos[i])) {
                    if (typeof value == "object") { datos[i][key] = "" } else { datos[i][key] = value.toString() }
                }
            }
            setTimeout(() => {
                $(`#${this.tableName}`).DataTable({
                    dom: "iftlp",
                    lengthMenu: [
                        [20, 50, 100],
                        [20, 50, 100],
                    ],
                    paginate: true,
                    pageLength: 20,
                    responsive: {
                        details: {
                            type: 'column'
                        }
                    },
                    columnDefs: [{
                        className: 'dtr-control',
                        orderable: false,
                        targets: 0
                    }],
                    /*  order: [1, 'desc'], */
                    language: {
                        sProcessing: "Procesando...",
                        sLengthMenu: "Mostrar _MENU_ registros",
                        sZeroRecords: "No se encontraron resultados",
                        sEmptyTable: "Sin registros encontrados",
                        sInfo: "",
                        sInfoEmpty: "",
                        sInfoFiltered: "",
                        sInfoPostFix: "",
                        search: "",
                        searchPlaceholder: "Filtrar...",
                        sUrl: "",
                        sInfoThousands: ",",
                        sLoadingRecords: "Cargando...",
                        oPaginate: {
                            sFirst: "Primero",
                            sLast: "Último",
                            sNext: "&raquo;",
                            sPrevious: "&laquo;",
                        },
                        oAria: {
                            sSortAscending:
                                ": Activar para ordenar la columna de manera ascendente",
                            sSortDescending:
                                ": Activar para ordenar la columna de manera descendente",
                        },
                    },
                });
            });
            this.datos = datos
            this.movimientos = true;
        },
        async ObtenerRegistrosSinCI() {
            let resp = await Expediente.ObtenerRegistrosExpSinCI(this);
            let datos = resp;
            for (let i in datos) {
                for (const [key, value] of Object.entries(datos[i])) {
                    if (typeof value == "object") {
                        datos[i][key] = ""
                    } else {
                        if (key != "exresp") { datos[i][key] = value.toString() }
                    }
                }
            }
            setTimeout(() => {
                $(`#${this.tableName}`).DataTable({
                    dom: "iftlp",
                    lengthMenu: [
                        [20, 50, 100],
                        [20, 50, 100],
                    ],
                    paginate: true,
                    pageLength: 20,
                    responsive: {
                        details: {
                            type: 'column'
                        }
                    },
                    columnDefs: [{
                        className: 'dtr-control',
                        orderable: false,
                        targets: 0
                    }],
                    order: [1, 'asc'],
                    language: {
                        sProcessing: "Procesando...",
                        sLengthMenu: "Mostrar _MENU_ registros",
                        sZeroRecords: "No se encontraron resultados",
                        sEmptyTable: "Sin registros encontrados",
                        sInfo: "",
                        sInfoEmpty: "",
                        sInfoFiltered: "",
                        sInfoPostFix: "",
                        search: "",
                        searchPlaceholder: "Filtrar...",
                        sUrl: "",
                        sInfoThousands: ",",
                        sLoadingRecords: "Cargando...",
                        oPaginate: {
                            sFirst: "Primero",
                            sLast: "Último",
                            sNext: "&raquo;",
                            sPrevious: "&laquo;",
                        },
                        oAria: {
                            sSortAscending:
                                ": Activar para ordenar la columna de manera ascendente",
                            sSortDescending:
                                ": Activar para ordenar la columna de manera descendente",
                        },
                    },
                });
            });
            this.datos = datos;
            this.movimientos = true;
        }
    },
}

</script>
<style>
.v-data-table-header {
    font-weight: bold;
    background-color: success;
}

#titulocard {
    color: white;
}
</style>